<template>
  <div>
    <v-card>
      <v-list flat>
        <v-row class="align-center mx-4">
          <h4>Product select</h4>
          <v-btn
            depressed
            :loading="loading"
            color="white"
            class="d-flex justify-center align-center"
          ></v-btn>
        </v-row>
        <!-- <v-checkbox v-if="isFOC" v-model="isFocSelected" label="FOC"></v-checkbox> -->
        <v-text-field
          filled
          v-model="prodsearchwithin"
          clearable
          label="search within.."
          type="text"
          class="mx-4 Caption"
        />
        <v-list-item-group color="primary">
          <v-list-item
            v-for="match in matches"
            :key="match.STKMST_DOCNO"
            @click="selectThisProduct(match)"
          >
            <v-card
              class="my-1"
              v-bind:class="[
                match.STTRN_QTY <= 0
                  ? { prodcardblocked: true }
                  : { prodcardactive: true },
              ]"
            >
              <v-list-item-content>
                <v-list-item-title
                  class="subtitle-1 text-wrap mx-3"
                  v-text="match.STKMST_DESC"
                />
                <v-row dense>
                  <v-col cols="6">
                    <v-list-item-subtitle class="caption text-wrap mx-3 my-1">
                      Code:
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="body-1 text-wrap mx-3 my-1">
                      {{ match.STKMST_DOCNO }}
                    </v-list-item-subtitle>
                  </v-col>
                  <v-col cols="6">
                    <v-list-item-subtitle class="caption text-wrap mx-3 my-1">
                      Stock:
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="body-1 text-wrap mx-3 my-1">
                      {{
                        match.STTRN_QTY + " " + match.STKMST_UNIT_DOCNO + "(s)"
                      }}
                    </v-list-item-subtitle>
                  </v-col>
                  <v-col cols="12">
                    <v-divider class="primary" />
                  </v-col>
                </v-row>
                <v-row dense v-show="match.LP_QTY > 0">
                  <v-list-item-subtitle
                    class="subtitle-1 text-wrap mx-3 my-1 primary--text"
                  >
                    Last purchase:
                  </v-list-item-subtitle>
                </v-row>
                <v-row dense v-show="match.LP_QTY > 0">
                  <v-col cols="3">
                    <v-list-item-subtitle class="caption text-wrap mx-3 my-1">
                      Date:
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="caption text-wrap mx-3 my-1">
                      {{ match.LP_DOCDATE }}
                    </v-list-item-subtitle>
                  </v-col>
                  <v-col cols="3">
                    <v-list-item-subtitle class="caption text-wrap mx-3 my-1">
                      Qty:
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="body-2 text-wrap mx-3 my-1">
                      {{ match.LP_QTY }}
                    </v-list-item-subtitle>
                  </v-col>
                  <v-col cols="3">
                    <v-list-item-subtitle class="caption text-wrap mx-3 my-1">
                      Unit:
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="body-2 text-wrap mx-3 my-1">
                      {{ match.LP_UNIT }}
                    </v-list-item-subtitle>
                  </v-col>
                  <v-col cols="3">
                    <v-list-item-subtitle class="caption text-wrap mx-3 my-1">
                      Rate:
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="body-2 text-wrap mx-3 my-1">
                      {{ match.LP_RATE }}
                    </v-list-item-subtitle>
                  </v-col>                  
                </v-row>
              </v-list-item-content>
            </v-card>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Prodselect",

  props: ["prodSearch"],

  data() {
    return {
      prodsearchwithin: "",
      // isFocSelected:false,
    };
  },

  computed: {
    allProductsList() {
      return this.$store.getters.allProducts;
    },
    selectedProductsList() {
      return this.$store.getters.selectedProducts;
    },
    thiscustomer() {
      return this.$store.getters.thiscustomer;
    },
    matches() {
      if (this.custSearch == "" && this.tgtType == "Customers") {
        return [];
      } else {
        return this.allProductsList.filter((product) =>
          product.STKMST_DESC.toLowerCase().includes(
            this.prodsearchwithin.toLowerCase()
          )
        );
      }
    },    
    // isFOC() {
    //   let stkdoc = this.selectedProductsList.filter(
    //     (product) => product.STKMST_DOCNO == match.STKMST_DOCNO
    //   );
    //   return (stkdoc.length >= 0)
    // },
    loading() {
      return this.$store.getters.loading;
    },
  },

  methods: {
    selectThisProduct(match) {
      this.$store.dispatch("selectThisProduct", match)
      this.$emit("hideSelectProduct")
      this.prodsearchwithin = ""
    },

    addProduct(match){
      // Find instances of this product is already in the list.
      const existingProduct  = this.selectedProductsList.find(
        product => product.STKMST_DOCNO == match.STKMST_DOCNO
      );     

      // If this is an FOC product, get the maximum percentage of the total value that can be added.
      if (match.STKMST_DETAILS_TXT2.startsWith('FOC') && existingProduct) {
        const maxPercentage = parseInt(match.STKMST_DETAILS_TXT2.slice(3)) / 100;
        
        // Calculate the total value that this product would have after adding the new quantity.
        const newFOCValue = match.SO_QTY * existingProduct.SO_RATE;        
        
        // If adding the new value would exceed the maximum percentage, don't add the product.
        if (newFOCValue > existingProduct.SO_LINE_TOTAL * maxPercentage) {
         alert("Maximum FOC value for this product exceeded");
          return;
        }
      }
      
      // If this is not an FOC product and it's already in the list, don't add it.
      else if (existingProduct && !match.STKMST_DETAILS_TXT2.startsWith('FOC')) {
        alert("Product already added");
        return;
      }
      
      // If we have passed all the conditions, add the product to the list.
      match.SO_QTY = 0;
      match.SO_RATE = match.LP_RATE;
      match.SO_LINE_TOTAL = 0;
      this.$store.dispatch("addProductToList", match);
      console.log(existingProduct );
    },
    addProductFOC(match) {
      const stkdoc = this.selectedProductsList.filter(
        (product) => product.STKMST_DOCNO == match.STKMST_DOCNO
      );

      // const isFOC = match.STKMST_DETAILS_TXT2.startsWith('FOC');
      // const maxQty = parseInt(match.STKMST_DETAILS_TXT2.slice(3));

      // const totalQty = stkdoc.reduce((sum, STKMST_DOCNO) => sum + product.SO_QTY, 0);

      if (stkdoc.length == 0 ) {
      // if ((isFOC && stkdoc.length < maxQty) || (!isFOC && stkdoc.length == 0)) {
        match.SO_QTY = 0
        match.SO_RATE = match.LP_RATE
        match.SO_LINE_TOTAL = 0
        this.$store.dispatch("addProductToList", match);
        console.log(stkdoc)
      } else {
        console.log("Product already added")
      }
    },
    // isFOC(match) {
    //   let stkdoc = this.selectedProductsList.find(
    //     (product) => product.STKMST_DOCNO == match.STKMST_DOCNO  && product.STKMST_DETAILS_TXT2.slice(0, 3) == "FOC"
    //   );
    //   return !!stkdoc; // returns true if stkdoc is not null or undefined, false otherwise
    // },
    // maxQtyFOC(match) {
    //   let matchedProducts = this.selectedProductsList.filter(
    //     product => product.STKMST_DOCNO == match.STKMST_DOCNO && product.STKMST_DETAILS_TXT2.startsWith('FOC')
    //   );

    //   return matchedProducts.map(
    //     product => parseInt(product.STKMST_DETAILS_TXT2.slice(3))
    //   );
    // }
    
  },
  mounted() {
    this.prodsearchwithin = ""
  },
};
</script>

<style scoped>
.prodcardblocked {
  border-left: 3px solid red;
}

.prodcardactive {
  border-left: 3px solid green;
}
</style>
